// extracted by mini-css-extract-plugin
module.exports = {"header_container":"Header_header_container__SeA-l","header":"Header_header__1VCKf","navigation":"Header_navigation__1NvSa","link":"Header_link__2wI74","logo":"Header_logo__3_SJs"};